export default __webpack_public_path__ + "static/media/retratoMedico.70a50cf1.jpg";